function fInitNews() {  
    function handleLoadClick(event) {
        event.preventDefault();

        const params = new URLSearchParams(event.target.getAttribute('href'));
        const p = params.get('p');
        const id = event.target.getAttribute('data-page');
        fFilterNewsArticles(p, id);
    }

    function bindHandlers (el) {
        el.addEventListener(('click'), handleLoadClick, true);
    }

    function fFilterNewsArticles (page, pageid) {
        let oRequest = new XMLHttpRequest();

        oRequest.open('GET', `/Umbraco/Surface/NewsOverview/GetAvailableNewsArticles?p=${page}&id=${pageid}`, true);
        oRequest.onreadystatechange = () => {
            if (oRequest.readyState === XMLHttpRequest.DONE) {
                if (oRequest.status === 200) {
                    let newsResultsContainer = document.querySelector('.js-news-results');
                    history.pushState({}, `Pagina ${page}`, `?p=${page}`);

                    // Remove old Load More button
                    newsResultsContainer.querySelector('.js-news-load').parentElement.remove();

                    // Insert Response HTML
                    newsResultsContainer.insertAdjacentHTML('beforeend', oRequest.responseText);

                    // Bind click handler to new load more button
                    if(newsResultsContainer.querySelector('.js-news-load')) {
                        bindHandlers(newsResultsContainer.querySelector('.js-news-load'));
                    }
                } else {
                    // Error
                }
            }
        };
        oRequest.send();
    }

    if (document.querySelector('.js-news-load')) {
        bindHandlers(document.querySelector('.js-news-load'));
    }
}
